class Line {
    constructor({
        m,
        c
    }) {
        this.m = m,
        this.c = c
    }
    static getLineIntersect({f, g}) {
        if (f.m === g.m) return null;

        const x = (g.c - f.c) / (f.m - g.m);
        const y = f.f(x);
        return { x, y };
    }
    static midpoint({A, B}) {
        const coordinates = {
            x: (A.x + B.x) / 2,
            y: (A.y + B.y) / 2
        }
        return coordinates;
    }
    static _cal_gradient({A, B}) { return (B.y - A.y) / (B.x - A.x); }
    static _cal_constant({A, m}) { return A.y - (m * A.x); }
    static fromPoints({
        A,
        B
    }) {
        this.m = Line._cal_gradient({A, B});
        this.c = Line._cal_constant({A, m: this.m});

        return new Line({m: this.m, c: this.c});
    }
    whereYis(y) { return (y - this.c) / this.m; }
    f(x) { return (this.m * x) + this.c; }
}

function lerp(a, b, t) {
  return {
    x: (1 - t) * a.x + t * b.x,
    y: (1 - t) * a.y + t * b.y
  };
}

export {
    Line,
    lerp
}